import { HttpHeaders } from "@angular/common/http";

export class APIData {
    filterId: number;
    periods: string[];
    organisationWKey: number;
    headers: HttpHeaders;
    hasAccessToCore: boolean;
}
